import { render, staticRenderFns } from "./MtProductsModal.vue?vue&type=template&id=cf05e68e&scoped=true&"
import script from "./MtProductsModal.vue?vue&type=script&lang=js&"
export * from "./MtProductsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf05e68e",
  null
  
)

export default component.exports